import { IComponentsService } from "../../interfaces/IComponentsService";
import { IComponentGameObject } from "../../interfaces/IComponentGameObject";
import { IComponent } from "../../interfaces/IComponent";
import { TableScreen } from "../screen/TableScreen";
import { Player } from "../player/Player";
import { Card } from "../card/Card";
import { TableStack } from "../cardStack/TableStack";
import { AppSettings } from "../managers/AppSettings";
import { CardStackSocket } from "../../types/types";
import { TrumpSuit } from "../state/TableStateMachine";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { CardsManager } from "../managers/CardsManager";
import { AppTimings } from "../data/AppConstants";


export class DealerPlayerToTable
    implements IComponent {
    private table!: TableScreen;
    // private components!: IComponentsService;

    public tableStack: TableStack;
    private inputData: any;

    /**
     * Amount by which lying card moves, when dealt card lands on top of it
     */
    private cardNudgePositionAmount: number = 15;
    private cardNudgeAngleAmount: number = 0.03;
    private cardNudgeEase: Function = Phaser.Math.Easing.Cubic.Out;
    /**
     * Reference to Card that is currently being dealt.
     */
    private dealtCard: Card;
    private waitTween: Phaser.Tweens.Tween;


    public constructor(tableStack: TableStack) {
        this.tableStack = tableStack;
    }

    public Init(go: IComponentGameObject, components: IComponentsService): void {
        this.table = go as TableScreen;
        // this.components = components;
    }

    public SetData(inputData: any): void {
        this.inputData = inputData;
        // console.log(TaskType[this.inputData.taskType]);
    }

    public GetData(): any {
        return this.inputData;
    }

    /**
     * Deal single card from player to table
     * NOTE: data model allows for multiple cards, but this function only uses first 
     *       from said model (can support multiple modes for the future).
     * 
    inputData: {
        taskType: TaskTypeBelote.DEAL_PLAYER_TO_TABLE,
        onComplete: this.OnTaskComplete.bind(this),
        playerIndex: taskData.playerIndex,
        cards: [taskData.card],
    }
     */
    public Deal(): void {
        // console.log("Deal:",this.inputData);

        const playerIndex: number = this.inputData.playerIndex;
        const player: Player = this.table.players.GetPlayerByIndex(playerIndex);
        this.dealtCard = this.inputData.cards[0];
        const rankLeftToRight: boolean = OptionsDataManager.IsRankLeftToRight();
        const stackLeftToRight: boolean = OptionsDataManager.IsStackLeftToRight();

        /**
         * TODO move this to stateMAchine and only use it for AI
         * (player should deal as soon as card clicked)
         */
        // const cardDealPlayerToTableDelay = playerIndex == Players.PLAYER_INDEX ? 
        //     0 : OptionsDataManager.GetTiming(AppTimings.cardDealPlayerToTableDelay);

        const cardTM: Phaser.GameObjects.Components.TransformMatrix = this.dealtCard.getWorldTransformMatrix();
        const tableCardAngle = this.dealtCard.angle + this.dealtCard.parentContainer.angle;
        const cardContainerScale = this.dealtCard.parentContainer.scale;
        const tableStackScale = this.tableStack.scale;
        player.PickCard(this.dealtCard);
        // this.table.add(this.dealtCard);
        this.table.cardContainer.add(this.dealtCard);
        this.dealtCard.angle = tableCardAngle;
        this.dealtCard.setPosition(cardTM.tx, cardTM.ty);
        this.dealtCard.scale = cardContainerScale;

        const stackSocket: CardStackSocket = this.tableStack.GetSocket(this.inputData.playerIndex);
        let dealDuration = OptionsDataManager.GetTiming(AppTimings.cardDealPlayerToTableDuration);
        // dealDuration = 2000;
        let nudgeDuration = OptionsDataManager.GetTiming(AppTimings.cardDealCardNudgeDuration);
        let flipCard = !this.dealtCard.IsFrontFacing();
        // flipCard = false;
        // const tweenProps = flipCard ?
        //     { scaleY: tableStackScale } :
        //     // { scaleX: tableStackScale, scaleY: tableStackScale };
        //     { scale: tableStackScale };

        AppAudioPlayer.PlaySfxRandomFromCollection([
            SoundEffectKeys.dealXS2,
            SoundEffectKeys.dealXS3,
            SoundEffectKeys.dealXS4,
            SoundEffectKeys.dealXS5,
            SoundEffectKeys.dealXS6,
            SoundEffectKeys.dealXS7,
            SoundEffectKeys.dealXS8,
        ]);

        this.table.scene.tweens.add({
            targets: this.dealtCard,
            duration: dealDuration,
            x: this.tableStack.x + stackSocket.posX * tableStackScale,
            y: this.tableStack.y + stackSocket.posY * tableStackScale,
            // ...tweenProps,
            scale: tableStackScale,
            angle: stackSocket.angle,
            onComplete: () => {
                this.tableStack.DropCard(this.dealtCard, stackSocket);
                this.dealtCard.scale = 1;

                // drop card sound (?)
                // AppAudioPlayer.PlaySfxRandomFromCollection([
                //     SoundEffectKeys.dropS1,
                //     SoundEffectKeys.dropS2
                // ]);

                // slightly 'nudge' existing stack cards (to emulate 'top card just landed on bottom cards, that then moved a little)
                this.tableStack.GetCards().forEach((stackCard: Card, i: number) => {
                    if (stackCard != this.dealtCard) {
                        const targetX: number = stackCard.x + (stackCard.x - this.dealtCard.x) * this.cardNudgeAngleAmount;
                        const targetY: number = stackCard.y + (stackCard.y - this.dealtCard.y) * this.cardNudgeAngleAmount;
                        const targetAngle: number = stackCard.angle + this.cardNudgeAngleAmount * 0.5 - Math.random() * this.cardNudgeAngleAmount;
                        this.table.scene.tweens.add({
                            targets: stackCard,
                            duration: nudgeDuration,
                            ease: this.cardNudgeEase,
                            x: targetX,
                            y: targetY,
                            angle: targetAngle
                        });
                    }
                });

                const trumpSuit: TrumpSuit = this.table.GetStateMachine().GetData().trumpSuit;
                player.ReorderCards(
                    true, // animate
                    trumpSuit, // trumpSuit
                    rankLeftToRight, // rankLeftToRight
                    stackLeftToRight, // stackLeftToRight
                    false, // skipReorder?
                    // playerIndex != 2,
                );

                // after card dealt to table, wait a bit

                const cardDealPlayerToTableDelay = OptionsDataManager.GetTiming(AppTimings.cardDealPlayerToTableDelay);

                this.waitTween = this.table.scene.tweens.addCounter({
                    duration: cardDealPlayerToTableDelay,
                    onComplete: () => {
                        this.inputData.onComplete(this.inputData.taskType);
                    },
                });

                this.dealtCard = null;
            },
        });
        if (flipCard) {
            this.dealtCard.Flip(true, dealDuration);
        }
    }

    /**
     * Pool the card that is currently being dealt (if applicable)
     */
    public Reset(): void {
        if (this.dealtCard) {
            this.table.scene.tweens.killTweensOf(this.dealtCard);
            CardsManager.DropCard(this.dealtCard, false);
            this.dealtCard = null;
        }
        this.waitTween?.destroy();
    }
}